// hooks/useActivityTracker.js — Activity tracker state and CRUD
import { useState, useEffect, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { getAccessToken } from "../services/msalService";
import {
  fetchActivities,
  createActivity,
  updateActivity,
  deleteActivity,
} from "../services/activityService";

const STORAGE_KEY = "lekoil_activities";

const SEED_ACTIVITIES = [
  {
    id: "act-001",
    title: "Contract for Provision of Turnkey Drilling Services",
    description: "Turnkey drilling services contract for OPL 276 Uda well.",
    category: "Contracts",
    priority: "High",
    status: "In Progress",
    dueDate: new Date(Date.now() + 18 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
    userDept: "WELL ENGINEERING",
    entity: "276",
    contractor: "Bill Energy Services Limited",
    lookAhead: "Continue to follow up with NUIMS rep for MoM sign-off and contract close-out.",
    ownerEmail: "welleng.head@lekoil.com",
    ownerName: "Well Engineering Head",
    ownerJobTitle: "Head, Well Engineering",
    ownerDepartment: "Well Engineering",
    assignedTo: "scm.staff@lekoil.com",
    assignedToName: "Babatunde Adetona",
    createdBy: "scm.admin@lekoil.com",
    createdByName: "SCM Admin",
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updates: [
      { id: "u-101", date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), by: "scm.staff@lekoil.com", byName: "Babatunde Adetona", status: "In Progress", note: "MoM Pending NUIMS sign-off. Letter duly signed by LEKOIL but cannot be transmitted to NUIMS without the signed MoM.", lookAhead: "Continue to follow up with NUIMS rep for a close out." },
      { id: "u-102", date: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(), by: "scm.staff@lekoil.com", byName: "Babatunde Adetona", status: "In Progress", note: "Draft contract reviewed and shared with both parties. NUIMS engagement ongoing.", lookAhead: "Obtain NUIMS sign-off on MoM to allow contract transmission." },
    ],
  },
  {
    id: "act-002",
    title: "OPL 276 Long Lead Item Storage",
    description: "Storage and management of long lead items and accessories at SOWSCO yard for OPL 276 drilling campaign.",
    category: "Logistics",
    priority: "Medium",
    status: "In Progress",
    dueDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
    userDept: "WELL ENGINEERING",
    entity: "276",
    contractor: "SOWSCO",
    lookAhead: "Plan to move LLMs and Accessories to Shendian Yard in Trans-Amadi, PH.",
    ownerEmail: "welleng.head@lekoil.com",
    ownerName: "Well Engineering Head",
    ownerJobTitle: "Head, Well Engineering",
    ownerDepartment: "Well Engineering",
    assignedTo: "scm.staff@lekoil.com",
    assignedToName: "Babatunde Adetona",
    createdBy: "scm.admin@lekoil.com",
    createdByName: "SCM Admin",
    createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updates: [
      { id: "u-201", date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), by: "scm.staff@lekoil.com", byName: "Babatunde Adetona", status: "In Progress", note: "New Wellhead spares received from BILL ENERGY and stored at SOWSCO Yard.", lookAhead: "Plan to move LLMs and Accessories to Shendian Yard in Trans-Amadi, PH ongoing." },
    ],
  },
  {
    id: "act-003",
    title: "Logistics Operational Support at OPL 276",
    description: "Day-to-day logistics support for project team at Afi Uda Project Site.",
    category: "Logistics",
    priority: "High",
    status: "In Progress",
    dueDate: null,
    userDept: "SCM",
    entity: "276",
    contractor: "Gegun Logistics",
    lookAhead: "Continuous Logistics Operational Support.",
    ownerEmail: "operations.head@lekoil.com",
    ownerName: "Operations Head",
    ownerJobTitle: "Head, Operations",
    ownerDepartment: "Operations & Asset",
    assignedTo: "scm.staff2@lekoil.com",
    assignedToName: "Stephen Awak",
    createdBy: "scm.admin@lekoil.com",
    createdByName: "SCM Admin",
    createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updates: [
      { id: "u-301", date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), by: "scm.staff2@lekoil.com", byName: "Stephen Awak", status: "In Progress", note: "Provided logistics support for personnel transportation to Afi Uda Project Site including airport pickups and inter-site transfers.", lookAhead: "Continuous Logistics Operational Support." },
    ],
  },
  {
    id: "act-004",
    title: "Supply of PPEs for Otakikpo and OPL 276",
    description: "Procurement and supply of personal protective equipment for both field locations.",
    category: "HSE",
    priority: "High",
    status: "On Hold",
    dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
    userDept: "SHES",
    entity: "Otakikpo",
    contractor: "TBA",
    lookAhead: "Waiting for the nod from the SHES team for progression.",
    ownerEmail: "shes.manager@lekoil.com",
    ownerName: "SHES Manager",
    ownerJobTitle: "Manager, SHES",
    ownerDepartment: "SHES",
    assignedTo: "scm.staff3@lekoil.com",
    assignedToName: "Adakole Ochigbo",
    createdBy: "scm.admin@lekoil.com",
    createdByName: "SCM Admin",
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updates: [
      { id: "u-401", date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), by: "scm.staff3@lekoil.com", byName: "Adakole Ochigbo", status: "On Hold", note: "Samples inspected by the SHES Team. Awaiting final approval to proceed with full order.", lookAhead: "Waiting for the nod from the SHES team for progression." },
    ],
  },
  {
    id: "act-005",
    title: "Supplier Onboarding & Revalidation",
    description: "Onboarding and revalidation of active supplier list. 55 of 160 suppliers completed verification.",
    category: "Procurement",
    priority: "Medium",
    status: "In Progress",
    dueDate: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
    userDept: "SCM",
    entity: "NIG.",
    contractor: "N/A",
    lookAhead: "Create a new ASL, generate ID and send to those with completed verification.",
    ownerEmail: "scm.head@lekoil.com",
    ownerName: "SCM Head",
    ownerJobTitle: "Head, SCM",
    ownerDepartment: "Supply Chain",
    assignedTo: "scm.staff4@lekoil.com",
    assignedToName: "Adaolisa Okonkwo",
    createdBy: "scm.admin@lekoil.com",
    createdByName: "SCM Admin",
    createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    updates: [
      { id: "u-501", date: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(), by: "scm.staff4@lekoil.com", byName: "Adaolisa Okonkwo", status: "In Progress", note: "List of active suppliers collated. 55/160 suppliers have completed verification process.", lookAhead: "Create new ASL, generate supplier IDs and notify verified suppliers." },
    ],
  },
];

function loadLocalActivities() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch {}
  return SEED_ACTIVITIES;
}

function saveLocalActivities(activities) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(activities)); } catch {}
}

export function useActivityTracker() {
  const { instance, accounts } = useMsal();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDemoMode, setIsDemoMode] = useState(true);
  const [spError, setSpError] = useState(null); // exposed so UI can show why SP failed

  const load = useCallback(async () => {
    setLoading(true);
    setSpError(null);
    try {
      const token = await getAccessToken(instance, accounts);
      const list = await fetchActivities(token);
      setActivities(list);
      setIsDemoMode(false);
    } catch (err) {
      console.error("[ActivityTracker] SharePoint connection failed:", err.message);
      setSpError(err.message);
      setActivities(loadLocalActivities());
      setIsDemoMode(true);
    } finally {
      setLoading(false);
    }
  }, [instance, accounts]);

  useEffect(() => { load(); }, [load]);

  // ── Create ────────────────────────────────────────────────────────────────

  const addActivity = useCallback(async (data) => {
    const now = new Date().toISOString();
    const item = {
      ...data,
      id: `act-${Date.now()}`,
      createdAt: now,
      updatedAt: now,
      updates: data.updates || [],
    };
    if (isDemoMode) {
      const updated = [item, ...activities];
      setActivities(updated);
      saveLocalActivities(updated);
      return item;
    }
    const token = await getAccessToken(instance, accounts);
    const created = await createActivity(token, item);
    setActivities((prev) => [created, ...prev]);
    return created;
  }, [isDemoMode, activities, instance, accounts]);

  // ── Bulk create ───────────────────────────────────────────────────────────

  const addActivities = useCallback(async (list, { createdBy, createdByName, onProgress } = {}) => {
    const now = new Date().toISOString();
    const items = list.map((data, i) => ({
      ...data,
      id: `act-${Date.now()}-${i}`,
      createdBy: createdBy || "",
      createdByName: createdByName || "",
      createdAt: now,
      updatedAt: now,
      updates: [{
        id: `u-${Date.now()}-${i}`,
        date: now,
        by: createdBy || "",
        byName: createdByName || "",
        status: data.status || "Not Started",
        note: "Task created via bulk upload.",
        lookAhead: data.lookAhead || "",
      }],
    }));

    if (isDemoMode) {
      const updated = [...[...items].reverse(), ...activities];
      setActivities(updated);
      saveLocalActivities(updated);
      return { created: items, failed: [] };
    }

    const token = await getAccessToken(instance, accounts);
    const created = [];
    const failed = [];
    for (let i = 0; i < items.length; i++) {
      try {
        const c = await createActivity(token, items[i]);
        created.push(c);
      } catch (err) {
        failed.push({ item: items[i], error: err.message });
      }
      onProgress?.(i + 1, items.length);
    }
    if (created.length > 0) {
      setActivities((prev) => [...[...created].reverse(), ...prev]);
    }
    return { created, failed };
  }, [isDemoMode, activities, instance, accounts]);

  // ── Edit ──────────────────────────────────────────────────────────────────

  const editActivity = useCallback(async (id, data) => {
    const target = activities.find((a) => a.id === id);
    if (!target) return;
    const updated = { ...target, ...data, updatedAt: new Date().toISOString() };
    if (isDemoMode) {
      const list = activities.map((a) => (a.id === id ? updated : a));
      setActivities(list);
      saveLocalActivities(list);
      return;
    }
    const token = await getAccessToken(instance, accounts);
    await updateActivity(token, target._spItemId, updated);
    setActivities((prev) => prev.map((a) => (a.id === id ? updated : a)));
  }, [isDemoMode, activities, instance, accounts]);

  // ── Delete ────────────────────────────────────────────────────────────────

  const removeActivity = useCallback(async (id) => {
    if (isDemoMode) {
      const list = activities.filter((a) => a.id !== id);
      setActivities(list);
      saveLocalActivities(list);
      return;
    }
    const target = activities.find((a) => a.id === id);
    if (!target?._spItemId) throw new Error("No SharePoint ID");
    const token = await getAccessToken(instance, accounts);
    await deleteActivity(token, target._spItemId);
    setActivities((prev) => prev.filter((a) => a.id !== id));
  }, [isDemoMode, activities, instance, accounts]);

  // ── Add progress update ────────────────────────────────────────────────────

  const addProgressUpdate = useCallback(async (id, { status, note, lookAhead, byEmail, byName }) => {
    const target = activities.find((a) => a.id === id);
    if (!target) return null;
    const updateEntry = {
      id: `u-${Date.now()}`,
      date: new Date().toISOString(),
      by: byEmail,
      byName,
      status,
      note,
      lookAhead: lookAhead || "",
    };
    const updated = {
      ...target,
      status,
      lookAhead: lookAhead || target.lookAhead || "",
      updatedAt: new Date().toISOString(),
      updates: [updateEntry, ...(target.updates || [])],
    };
    if (isDemoMode) {
      const list = activities.map((a) => (a.id === id ? updated : a));
      setActivities(list);
      saveLocalActivities(list);
      return { activity: updated, update: updateEntry };
    }
    const token = await getAccessToken(instance, accounts);
    await updateActivity(token, target._spItemId, updated);
    setActivities((prev) => prev.map((a) => (a.id === id ? updated : a)));
    return { activity: updated, update: updateEntry };
  }, [isDemoMode, activities, instance, accounts]);

  // ── Toggle CFO Issue flag ─────────────────────────────────────────────────

  const toggleCFOIssue = useCallback(async (id, newValue) => {
    const target = activities.find((a) => a.id === id);
    if (!target) return null;
    const updated = {
      ...target,
      cfoIssue: newValue,
      cfoRecommendations: target.cfoRecommendations || [],
      updatedAt: new Date().toISOString(),
    };
    if (isDemoMode) {
      const list = activities.map((a) => (a.id === id ? updated : a));
      setActivities(list);
      saveLocalActivities(list);
      return updated;
    }
    const token = await getAccessToken(instance, accounts);
    await updateActivity(token, target._spItemId, updated);
    setActivities((prev) => prev.map((a) => (a.id === id ? updated : a)));
    return updated;
  }, [isDemoMode, activities, instance, accounts]);

  // ── Add CFO Recommendation ────────────────────────────────────────────────

  const addCFORecommendation = useCallback(async (id, { text, byEmail, byName }) => {
    const target = activities.find((a) => a.id === id);
    if (!target) return null;
    const rec = {
      id: `rec-${Date.now()}`,
      date: new Date().toISOString(),
      by: byEmail,
      byName,
      text,
    };
    const updated = {
      ...target,
      cfoRecommendations: [rec, ...(target.cfoRecommendations || [])],
      updatedAt: new Date().toISOString(),
    };
    if (isDemoMode) {
      const list = activities.map((a) => (a.id === id ? updated : a));
      setActivities(list);
      saveLocalActivities(list);
      return { activity: updated, recommendation: rec };
    }
    const token = await getAccessToken(instance, accounts);
    await updateActivity(token, target._spItemId, updated);
    setActivities((prev) => prev.map((a) => (a.id === id ? updated : a)));
    return { activity: updated, recommendation: rec };
  }, [isDemoMode, activities, instance, accounts]);

  return {
    activities,
    loading,
    isDemoMode,
    spError,
    refresh: load,
    addActivity,
    addActivities,
    editActivity,
    removeActivity,
    addProgressUpdate,
    toggleCFOIssue,
    addCFORecommendation,
  };
}
